import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nextCronRuns',
  standalone: true,
})
export class NextCronRunsPipe implements PipeTransform {
  transform(expr: string, count = 3, from: Date = new Date()): Date[] {
    if (!expr) return [];
    const parts = expr.trim().split(/\s+/);
    if (parts.length !== 5) return [];

    const [min, hour, dom, month, dow] = parts;
    const results: Date[] = [];

    const cursor = new Date(from);
    cursor.setSeconds(0, 0);
    cursor.setMinutes(cursor.getMinutes() + 1);

    for (let i = 0; i < 600000 && results.length < count; i++) {
      if (
        this.match(cursor.getMinutes(), min) &&
        this.match(cursor.getHours(), hour) &&
        this.match(cursor.getDate(), dom) &&
        this.match(cursor.getMonth() + 1, month) &&
        this.match(cursor.getDay(), dow)
      ) {
        results.push(new Date(cursor));
      }
      cursor.setMinutes(cursor.getMinutes() + 1);
    }

    return results;
  }

  private match(val: number, field: string): boolean {
    if (field === '*') return true;
    if (field.startsWith('*/')) return val % parseInt(field.slice(2)) === 0;
    if (field.includes(',')) return field.split(',').some(v => parseInt(v) === val);
    if (field.includes('-')) {
      const [lo, hi] = field.split('-').map(Number);
      return val >= lo && val <= hi;
    }
    return parseInt(field) === val;
  }
}
